import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { useEffect } from "react";

const RedirectUnknownRoutes = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        navigate("/", { replace: true });
    }, [user]);

    return <></>;
};

export default RedirectUnknownRoutes;
